export default "__VITE_ASSET__DduRp92X__"